function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M19 17a1 1 0 011 1v4a1 1 0 11-2 0v-4a1 1 0 011-1z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 8a5 5 0 015-5h1a5 5 0 015 5v1.088C9.869 10.984 7 15.157 7 20c0 6.627 5.373 12 12 12s12-5.373 12-12S25.627 8 19 8c-1.036 0-2.041.131-3 .378V8a7 7 0 00-7-7H8a7 7 0 00-7 7v3a1 1 0 102 0V8zm16 2c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10z",
  fill: "currentColor"
})));